import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        console.log('ERROR from interceptor: ', error);
        console.log('ERROR.error from interceptor: ', error.error);

        if (
          error.error &&
          typeof error.error === 'string' &&
          error.error.includes('<!DOCTYPE html>')
        ) {
          console.log('Error tipo HTML');
          const errorMessage =
            error.error.substr(error.error.indexOf('Error: '), 80) + '(...)';
          console.log(errorMessage);
          return throwError({ error: { error: { message: errorMessage } } });
        }
        console.log(
          'ERROR.error.message msg from interceptor: ',
          error.error.error.message
        );
        //alert(error.error.error.message);

        if ([401, 403].indexOf(error.status) !== -1) {
          // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
          this.authService.logout(
            'Se ha producido un error de autenticación. Por favor, inicie sesión de nuevo.'
          );
          //location.reload(true);
        }
        return throwError(error);
      })
    );
  }
}
